"use client";

import type * as React from "react";
import Box from "@mui/material/Box";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { BellSlashIcon } from "@phosphor-icons/react/dist/ssr/BellSlash";

export interface NotificationsPopoverProps {
	anchorEl: null | Element;
	onClose?: () => void;
	open?: boolean;
}

export function NotificationsPopover({
	anchorEl,
	onClose,
	open = false,
}: NotificationsPopoverProps): React.JSX.Element {
	return (
		<Popover
			anchorEl={anchorEl}
			anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
			onClose={onClose}
			open={open}
			slotProps={{ paper: { sx: { width: "320px" } } }}
			transformOrigin={{ horizontal: "right", vertical: "top" }}
		>
			<Box sx={{ px: 3, py: 2, borderBottom: "1px solid var(--mui-palette-divider)" }}>
				<Typography variant="h6">Notifications</Typography>
			</Box>
			<Stack spacing={1} sx={{ alignItems: "center", py: 4, px: 3 }}>
				<BellSlashIcon fontSize="var(--icon-fontSize-lg)" />
				<Typography color="text.secondary" variant="body2">
					No notifications yet
				</Typography>
			</Stack>
		</Popover>
	);
}
